var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgCsh = function SvgCsh(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.542 34.5c.282-.507.458-1.079.458-1.592V15.092c0-.513-.175-1.085-.458-1.592L24 24l17.542 10.5Z",
    fill: "#7F3A86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25.559 44.615 14.882-8.908c.429-.257.819-.7 1.101-1.207L24 24 6.458 34.5c.282.507.672.95 1.1 1.207l14.883 8.908c.858.513 2.26.513 3.118 0Z",
    fill: "#662579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.542 13.5c-.282-.508-.672-.95-1.1-1.207L25.558 3.385c-.858-.513-2.26-.513-3.118 0L7.56 12.293C6.7 12.806 6 14.066 6 15.092v17.816c0 .513.175 1.085.458 1.592L24 24l17.542-10.5Z",
    fill: "#9A5196"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.058 36C17.409 36 12 30.617 12 24s5.41-12 12.058-12c4.21 0 8.143 2.213 10.32 5.793l-5.163 3.097A6.061 6.061 0 0 0 24.058 18c-3.325 0-6.03 2.692-6.03 6s2.705 6 6.03 6a6.061 6.061 0 0 0 5.148-2.875l5.175 3.079A12.115 12.115 0 0 1 24.058 36Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 19.5v1.496h-3V19.5H33v1.496h-1.5V22.5H33v2.992h-1.5V27H33v1.5h1.5V27h3v1.5H39V27h1.5v-1.5H39v-3h1.5v-1.504H39V19.5h-1.5Zm0 6v-3h-3v2.992l3 .008Z",
    fill: "#fff"
  })));
};

export default SvgCsh;